<mat-dialog-content style="max-height: 60vw;">
  <div id="w3l-appointment" style="background-color: bisque;">
  <section >
    <div class="form-inner-cont" style="background-color: bisque;">
      <div >
          <h1 style="background-color: rgb(1, 19, 58);color: white;text-align: center;">{{'Patient Info' | translate }}</h1>
      </div>
    </div>
  </section>
  </div>
  <BR>
  <div class="top-header" >
    <div class="d-grid grid-columns-top-3">

        <div class="accounts" style="left: 50px;">

          <div style="display: flex;">
            <label style="font-size: large;font-weight: bold;left: 150px;width: 7%;">  Patient : </label>

            <label style="font-size: large;left: 50px;width: 10%;">{{patientCode}}</label>
            <label style="font-size: large;font-weight: bold;left: 150px;width: 2%;"></label>
            <label style="font-size: large;left: 190px;width: 15%;">{{patientFName}}</label>

            <label style="font-size: large;font-weight: bold;left: 150px;width: 2%;"></label>

            <label style="font-size: large;font-weight: bold;width: 10%;">Date of Birth: </label>
            <label style="font-size: large;width: 15%;">{{birthDate}}</label>
            <label style="font-size: large;font-weight: bold;left: 150px;width: 2%;"></label>
            <label style="font-size: large;font-weight: bold;width: 10%;">Age : </label>
            <label style="font-size: large;width: 15%;">{{ageYear}} Year</label>

          </div>
          <br>
          <mat-divider></mat-divider>
          <div style="display: flex;">
            <label style="font-size: large;font-weight: bold;left: 150px;width: 7%;">   Gender : </label>

            <label style="font-size: large;left: 50px;width: 10%;">{{gender}}</label>
            <label style="font-size: large;font-weight: bold;left: 150px;width: 2%;"></label>
            <label style="font-size: large;left: 190px;width: 15%;">{{marital}}</label>

            <label style="font-size: large;font-weight: bold;left: 150px;width: 2%;"></label>

            <label style="font-size: large;font-weight: bold;width: 10%;">1st. Visit: </label>
            <label style="font-size: large;width: 15%;">{{dateEntry}}</label>
            <label style="font-size: large;font-weight: bold;left: 150px;width: 2%;"></label>
            <label style="font-size: large;font-weight: bold;width: 10%;">Doctor : </label>
            <label style="font-size: large;width: 15%;">{{doctorname}}</label>




          </div>
          <br>
          <mat-divider></mat-divider>
          <div style="display: flex;">
            <label style="font-size: large;font-weight: bold;left: 150px;width: 7%;">  Mobile : </label>

            <label style="font-size: large;left: 50px;width: 10%;">{{telMobile}}</label>
            <label style="font-size: large;font-weight: bold;left: 150px;width: 2%;"></label>
            <label style="font-size: large;left: 190px;width: 15%;">{{telBusin}}</label>

            <label style="font-size: large;font-weight: bold;left: 150px;width: 2%;"></label>

            <label style="font-size: large;font-weight: bold;width: 10%;">e-mail: </label>
            <label style="font-size: large;width: 15%;">{{email}}</label>
            <label style="font-size: large;font-weight: bold;left: 150px;width: 2%;"></label>
            <label style="font-size: large;font-weight: bold;width: 10%;">Nationalty : </label>
            <label style="font-size: large;width: 15%;">{{nationality}}</label>


          </div>
          <br>
          <mat-divider></mat-divider>
            <div style="display: flex;">
            <label style="font-size: large;font-weight: bold;left: 150px;width: 7%;">  Phone  : </label>

            <label style="font-size: large;left: 50px;width: 10%;">{{telHome}}</label>
            <label style="font-size: large;font-weight: bold;left: 150px;width: 2%;"></label>
            <label style="font-size: large;left: 190px;width: 15%;"> </label>

            <label style="font-size: large;font-weight: bold;left: 150px;width: 2%;"></label>

            <label style="font-size: large;font-weight: bold;width: 10%;">Marital status</label>
            <label style="font-size: large;width: 15%;">{{mstatustext}}</label>
            <label style="font-size: large;font-weight: bold;left: 150px;width: 2%;"></label>
            <label style="font-size: large;font-weight: bold;width: 10%;"></label>
            <label style="font-size: large;width: 15%;"></label>


          </div>
          <br>

        </div>
    </div>
</div>
<BR><BR>
<div style="text-align: center ">
   <button type="button" class="theme-button btn" style="width: 10%;height: 60px;font-weight: bold;background-color: rgb(1, 19, 58);color: white;border-style: none;height: 60%;" name="Back"  (click)="CloseDialog()">Close</button>
</div>
</mat-dialog-content>
